// Costo en CRÉDITOS por acción (1 crédito ≈ $0.10). Aprobado por el dueño.
export const CREDIT_USD = 0.10;

// Créditos de una escena de video por duración: 10s = 11, 5s = 6.
export const sceneCredits = (durationSec) => {
  const d = Number(durationSec) || 6;
  if (d <= 5) return 6;
  if (d <= 6) return 7;
  if (d <= 8) return 9;
  return 11;
};

export const songCredits = () => 4;
// El backend fuerza duración 6s para PRO (Kling) => 7 cr/toma, sin importar la duración elegida.
export const videoCredits = (durationSec, takes = 2, quality = "standard") =>
  sceneCredits(quality === "pro" ? 6 : durationSec) * Math.max(1, takes);
export const shortfilmSceneCredits = (durationSec) => sceneCredits(durationSec);
// Escena de diálogo (audio-first, Kling Avatar Pro + voz clonada): costo real / 0.06 (~40% margen).
export const dialogueSceneCredits = (durationSec) => {
  const d = Number(durationSec) || 6;
  const cost = 0.115 * d + 0.03;
  return Math.max(1, Math.ceil(cost / 0.06));
};
export const filmSceneCredits = (scene) =>
  scene?.type === "dialogue" ? dialogueSceneCredits(scene.duration) : sceneCredits(Number(scene?.duration || 6));
export const filmTotalCredits = (scenes) =>
  (scenes || []).reduce((a, s) => a + filmSceneCredits(s), 0);
export const shortfilmTotalCredits = (scenes) =>
  (scenes || []).reduce((a, s) => a + sceneCredits(Number(s.duration || 6)), 0);
export const lipsyncCredits = (numScenes = 1) => 4 * Math.max(1, numScenes);

export const fmtCredits = (c) => `${Math.round(Number(c) || 0)} cr`;
export const fmtCreditsUsd = (c) => `$${((Number(c) || 0) * CREDIT_USD).toFixed(2)}`;

// Compat: código antiguo importaba estas. Ahora devuelven créditos.
export const shortfilmCost = shortfilmSceneCredits;
export const fmtUsd = fmtCredits;
